"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAudioComponentParameters = void 0;
exports.UserAudioComponentParameters = [
    {
        id: 'bitwidth',
        label: 'Bitwidth',
        description: 'Input Param - Bitwidth of the audio recording',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            '8': '8 bits per sample',
            '16': '16 bits per sample',
        },
        required: true,
    },
    {
        id: 'sampling_rate',
        label: 'Sampling Rate',
        description: 'Input Param - Sampling rate of the audio recording',
        type: 'enum',
        paramType: 'ENUM',
        list: {
            '8k': '8 KHz',
            '16k': '16 KHz',
            '44k': '44.1 KHz',
        },
        required: true,
    },
    {
        id: 'show_amplitudes',
        label: 'Show Amplitudes',
        description: 'Input Param - Whether to display audio amplitudes',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'compress',
        label: 'Compress Audio',
        description: 'Input Param - Whether or not to compress the audio recording',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'min_recording_length',
        label: 'Minimum length of recording',
        description: 'Input Param - Minimum length of recording (in seconds)',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'max_recording_length',
        label: 'Maximum length of recording',
        description: 'Input Param - Maximum length of recording (in seconds)',
        type: 'int',
        paramType: 'INT',
        required: false,
    },
    {
        id: 'autoPlay',
        label: 'Automatic Play',
        description: 'Input Param - Whether to automatically play the recording after recording',
        type: 'boolean',
        paramType: 'BOOLEAN',
        required: false,
    },
    {
        id: 'recording',
        label: 'Recording',
        description: 'Output Param - Genereted recording file',
        type: 'output',
        paramType: 'FILE',
        required: true,
    },
    {
        id: 'duration',
        label: 'Duration of Recording',
        description: 'Output Param - Duration of generated recording file',
        type: 'output',
        paramType: 'INT',
        required: true,
    },
];
//# sourceMappingURL=UserAudioComponent.js.map